/**
 * Product Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/product.liquid
 *
 */


 import Vue from 'vue';
 import axios from 'axios';
 import filter from 'lodash-es/filter';
 import Slick from 'vue-slick';
 import {getUrlWithVariant} from '@shopify/theme-product-form';

 import ImageZoom from './image-zoom.vue';
 import Accordion from './accordion.vue';
 import Collapsible from './collapsible.vue';

// @TODO: Update with real endpoints
const apiEndpoints = {
  dev: 'https://shopifypeoplevoxapp-dev.testarc.com.au',
  prod: 'https://shopifypeoplevoxapp.testarc.com.au'
};

function getApiEndpoint() {
  return window.location.hostname == 'white-fox-boutique-develop.myshopify.com' ? apiEndpoints.dev : apiEndpoints.prod;
}

Vue.component('product', {
  components: {
    Slick,
    ImageZoom,
    Accordion,
    Collapsible
  },

  props: [
    'productObject',
    'appAddToCart',
    'explicitGroup',
    'inventory',
    'isProductPage',
  ],

  data() {
    return {
      activeVariants: {},
      isLoadingProduct: false,
      isSubmitting: false,
      isSizeGuideOpen: false,
      product: null,
      options: [],
      variantLoyaltyData: window.loyaltyConfig?.variantData || null,
      options_with_inventory: this.inventory,
      currentVariant: null,
        // siblings: [
        //     {
        //         "title": "Sibling product A",
        //         "handle": "test-product-with-variants-a",
        //         "colour": "colour:gold"
        //     },
        //     {
        //         "title": "Sibling product B",
        //         "handle": "test-product-with-variants-b",
        //         "colour": "colour:silver"
        //     },
        //     {
        //         "title": "Sibling product C",
        //         "handle": "test-product-with-variants-c",
        //         "colour": "colour:white"
        //     },
        //     {
        //         "title": "Sibling product D",
        //         "handle": "test-product-with-variants-d",
        //         "colour": "colour:green"
        //     },
        //     {
        //         "title": "Sibling product E",
        //         "handle": "test-product-with-variants-e",
        //         "colour": "colour:blue"
        //     },
        // ],

      siblings: [],
      sibling: null,

      mainSlickOptions: {
        dots: true,
        appendDots: '.gallery__controls',
        slidesToShow: (this.isProductPage) ? 2 : 1,
        focusOnSelect: true,
        arrows: true,
        appendArrows: '.gallery__controls',
        asNavFor: '.gallery__nav',
        infinite: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },

      navSlickOptions: {
        slidesToShow: 4,
        focusOnSelect: true,
        vertical: true,
        arrows: false,
        infinite: true,
        asNavFor: '.gallery__main',
        adaptiveHeight: false
      },

    }
  },

  computed: {
    loyaltyMessage() {
      if (!this.currentVariant || !this.variantLoyaltyData) return '';

      const points = this.variantLoyaltyData[this.currentVariant.id];
      if (!points) return '';

      const messageTemplate = window.loyaltyConfig?.messageTemplate || 'Earn __POINTS__ points';
      return messageTemplate.replace('__POINTS__', points);
    },
    promoMessageHtml() {
      const product = this.productObject || this.product;
      if (!product?.tags?.length) {
        return '';
      }

      const price = this.currentVariant?.price ?? product.price;
      return window.theme?.promoMessageGenerator?.(product.tags, price) || '';
    },
  },

  methods: {

    setActiveVariant({ productId, variantId }) {
      console.log("Setting active variant for product:", productId, "to variant:", variantId);
      this.$set(this.activeVariants, productId, variantId);
  },

    getColourName(name) {
      return `colour-colour-${ name }.png`;
    },

    toggleSizeGuide: function() {
      this.isSizeGuideOpen = !this.isSizeGuideOpen;
    },


    updateVariant: function() {
      let variant = this._findVariant();
      console.log(variant);
      this._setVariant(variant);
      if(variant.available) {
        $('#ProductSelect-product').val(variant.id)
        $('.shopify-product-form').removeClass('d-none');
      } else {
        $('.shopify-product-form').addClass('d-none');
      }
    },


    handleAddToCart: function () {
      if (!this.currentVariant) {
        console.error('No current variant');
        return;
      }



      const productInfo = {
        id: this.product.id,
        title: this.product.title,
        price: this.currentVariant.price,
        variant_title: this.currentVariant.public_title,
        category: this.product.type,
      };

      const payload = {
        variantId: this.currentVariant.id,
        productInfo: productInfo,
      }

      this.isSubmitting = true;

      const args = [
        ... this.explicitGroup ? [this.explicitGroup] : [],
        payload
      ];

      this.appAddToCart(...args).then((response) => {
        // console.log('success');
        this.isSubmitting = false;
        this.isAddtocartConfirmationOpen = true;

      }).catch((error) => {
        console.log('error', error);
        this.isSubmitting = false;
        alert('Cannot reach the server at this time, please try again later.');
      });
    },

    goToSibling: function(path, sibling) {
      window.location = path + sibling.handle;
    },

    _findVariant: function() {
      for (let i = 0; i < this.product.variants.length; i++) {
        // console.log('variant', this.product.variants[i]);

        if (this.product.variants[i].option1 && this.product.variants[i].option1 != this.options[0]) continue;
        if (this.product.variants[i].option2 && this.product.variants[i].option2 != this.options[1]) continue;
        if (this.product.variants[i].option3 && this.product.variants[i].option3 != this.options[2]) continue;

        // console.log('variant found', this.product.variants[i]);
        return this.product.variants[i];
      }

      return null;
    },

    _setVariant: function(variant) {
      if (!variant) {
        this.currentVariant = null;
        return;
      }


      if (this.isProductPage) {
        if (variant.featured_image) {
          this.$refs.main.goTo(variant.featured_image.position - 1);
        }

        let url = getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({path: url}, '', url);
      }

      this.currentVariant = variant;
    },

    clickWishlist: function(event) {
      if ($(event.target).hasClass('iwishAdded')) {
        iwish_remove($(event.target),this.currentVariant.id.toString());
        $(event.target).removeClass('iwishAdded');

        let product_id = event.target.dataset.product;
        $('*[data-product="'+product_id+'"]').removeClass('iwishAdded');

      } else {

        iwish_add($(event.target),this.currentVariant.id.toString());
        let product_id = event.target.dataset.product;
        $('*[data-product="'+product_id+'"]').addClass('iwishAdded');

      }

      return false;
    },

    _getProduct() {

      this.product = this.productObject;

      // set current variant if avaiable
      let found = this.productObject.variants.find(variant => variant.available == true);

      this.currentVariant = found ?? this.productObject.variants[0];

      // if the URL has ?variant=[variant.id], select that variant
      let queryStringValues = new URLSearchParams(window.location.search);

      if (queryStringValues.has('variant')) {
        let variantFromQueryString = filter(this.product.variants, function(variant) {
          return variant.id == queryStringValues.get('variant');
        });

        if(variantFromQueryString.length > 0){
          this.currentVariant = variantFromQueryString[0]
        }
      }

      for (let i = 1; i <= this.product.options.length; i++) {
        this.options.push(this.currentVariant['option' + i]);
      }

      this.updateVariant();

      if (this.isProductPage) {
        axios.get(`${getApiEndpoint()}/siblings/get?id=${this.product.id}&shop=${Shopify.shop}`).then(response => {
          // console.log('siblings', response.data);
          let data = response.data;
          // Do not add current product to siblings
          data.forEach(item => {
            if (item.handle != this.productObject.handle) {
              // prevent duplicate items
              if (item.handle.split('-')[0] === this.productObject.handle.split('-')[0]) {
                axios.get(`/products/${item.handle}.js`).then(response => {
                  item.image = response.data.images[1];
                  if (this.siblings.filter(x => x.handle === item.handle).length < 1) {
                    // console.log(item);
                    this.siblings.push(item);
                  }
                }).catch((error) => {
                  console.log('Error loading sibilings', error);
                });
              }
            }
          });

        }).catch((error) => {
          console.log('Error loading sibilings', error);
        });
      }

      // If product is in wishlist
      setTimeout(() => {
        checkIwish($('.product-detail'),this.currentVariant.id.toString());
      }, 1000);
    },

  },

  created() {

    console.log("Product : ", this.productObject);
    if (!this.isProductPage) {
      var checkPopupSlider = setInterval(() => {
        if (this.$refs.nav) {
          clearInterval(checkPopupSlider);
          setTimeout(() => {
            this.$refs.nav.reSlick();
          }, 100);
        }
      }, 100);
    }

    // Add a selling fast badge
    if (window.theme.IS_country) {
      var product_id = this.productObject.id;
      $.getJSON(`https://cloud.mail.whitefoxboutique.com/top-50-products?type=purchased&country=${window.theme.IS_country}`, function(response){
        var trending = [];
        for(var i = 0; i < response.length; i++) {
          var response_id = Number(response[i]);
          if(product_id == response_id) {
            trending.push(response_id);
          }
        }
        const hasBadges = document.querySelectorAll('.product-badge').length > 0;
        if (!hasBadges) {
          const badgeKey = window.theme.getProductBadgeKey?.(this.productObject.tags, {
            productId: product_id,
            trendingProductIds: trending,
          });
          const badgeText = window.theme.getProductBadgeText?.(badgeKey);
          if (badgeText) {
            document.querySelector('.gallery__main').insertAdjacentHTML('beforeend', `<div class="product-badge">${ badgeText }</div>`);
          }
        }
      });
    }

    window.addEventListener('load', function() {

      // Mobile watch product video button
      $('.mobile-video-button button').on('click', function() {
        // Find which slide index the video is in
        var video_index = $('.gallery-video').parent().parent().attr('data-slick-index');
        $('.gallery__main').slick('slickGoTo', video_index);
      });

      if (screen.width > 768) {
        // Initialise the zoom functionality
        $('.image-container').each(function(){
          $(this).zoom({
            url: $(this).attr('data-zoom'),
            touch: false
          });
        });
      }
    });
  },

  mounted(){
    // Refactored code
    this._getProduct();

  }
});
